import React from 'react';
import PropTypes from 'prop-types';

import styles from './lineItem.scss';

const PlanPricing = ({ planData, interval }) => {
    if (!planData) {
        return null;
    }

    const isAnnual = interval === 'year';
    const planName = `Power ${isAnnual ? 'Annual' : 'Monthly'} Plan`;
    const displayAmount = isAnnual ? planData?.displayAnnualAmount : planData?.displayAmountPayPerRecurringInterval;
    return (
        <div className={styles.lineItemSection}>
            <div className="d-flex flex-row">
                <div className={`flex-grow-1 ${styles.itemName}`}>
                    {planName}
                    {/* Boolean() so a 0 savings percentage renders nothing — a bare `&& 0` would
                        print the literal "0" next to the plan name. */}
                    {isAnnual && Boolean(planData?.savingsPercentage) && (
                        <span className="text-success ms-2">
                            {` `}(Save {planData?.savingsPercentage}%)
                        </span>
                    )}
                </div>
                <div className={`align-content-end ${styles.total}`}>
                    <span>{displayAmount}</span> total
                </div>
            </div>
        </div>
    );
};

PlanPricing.propTypes = {
    planData: PropTypes.shape({
        planId: PropTypes.string.isRequired,
        interval: PropTypes.string.isRequired,
        amountPayPerRecurringInterval: PropTypes.number.isRequired,
        displayAmountPayPerRecurringInterval: PropTypes.string.isRequired,
        monthlyAmount: PropTypes.number,
        displayMonthlyAmount: PropTypes.string,
        annualAmount: PropTypes.number,
        displayAnnualAmount: PropTypes.string,
        savingsPercentage: PropTypes.number,
    }),
    interval: PropTypes.string.isRequired,
};

PlanPricing.defaultProps = {
    planData: null,
};

export default PlanPricing;
